import useLazySelector from "common/redux/useLazySelector";
import * as MerchantActions from 'features/merchants/merchants.actions';
import ContractExtendedType from "domain/contractExtendedType";

const defaultVal: ContractExtendedType[] = [];
export default function useContractExtendedTypes(): ContractExtendedType[] {
    return useLazySelector(
        store => store.contractExtendedTypes,
        MerchantActions.loadMerchantContractExtendedTypes, null, defaultVal);
}
